import Step from './Step.vue';

export default Step;
